import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function EyeClosed(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), React.createElement("path", {
    d: "M1.454 5.019a.75.75 0 00-1.21.887l.606-.444-.605.444.002.002.003.005.01.014a5.147 5.147 0 00.175.223 16.015 16.015 0 001.418 1.506L.698 8.986a.75.75 0 001.132.985L3 8.625c.67.515 1.46 1.033 2.354 1.47l-1.009 2.772a.75.75 0 101.41.513l.988-2.714a10.32 10.32 0 002.504.517v3.37a.75.75 0 001.5 0v-3.368a10.314 10.314 0 002.521-.518l.988 2.713a.75.75 0 001.41-.513l-1.01-2.771a13.856 13.856 0 002.356-1.47l1.169 1.345a.75.75 0 101.132-.984l-1.156-1.33c.358-.332.66-.643.902-.907a13.34 13.34 0 00.694-.823l.01-.014.003-.005.002-.001-.56-.412.56.41a.75.75 0 00-1.21-.886l-.005.008a11.819 11.819 0 01-.6.71 14.597 14.597 0 01-1.769 1.634c-1.531 1.195-3.66 2.341-6.177 2.341-2.516 0-4.646-1.146-6.177-2.34a14.605 14.605 0 01-1.768-1.635 11.847 11.847 0 01-.6-.71l-.006-.008zm0 0h.001l-.605.443.605-.443z"
  }));
}

export { EyeClosed };
//# sourceMappingURL=EyeClosed.js.map